import axios from "axios";

class OtpAuthService {

    constructor() {
        this.apiBaseUrl = process.env.REACT_APP_OTP_AUTH;
        this.restClient = axios.create({
            baseURL: this.apiBaseUrl
        });
    }

    validateOTP(username, password, otp, authToken) {

        return this.restClient.post('/validate/login', {
            "userName": username,
            "password": password,
            "otp": otp
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            }
        });
    }

}

export default new OtpAuthService();